import React from 'react'
import autobind from 'autobind-decorator'
import getEnv from '../getEnv'

export default class Version extends React.Component {
  static propTypes = {}

  componentDidMount() {
    this.checkVersion()
    this.interval = setInterval(this.checkVersion, 30000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  @autobind
  async checkVersion() {
    if (getEnv() === 'local') return
    let path
    switch (getEnv()) {
      case 'dev':
        path = 'https://develop.orionx.com/waves-current-version.json'
        break
      case 'beta':
        path = 'https://beta.orionx.com/waves-current-version.json'
        break
      default:
        path = 'https://app.orionx.com/waves-current-version.json'
        break
    }
    const response = await fetch(path)
    const {version} = await response.json()
    console.log('[Current Client Version]: ', version)
    this.saveVersion(version)
  }

  saveVersion(newVersion) {
    const oldVersion = localStorage.getItem('clientVersion')
    localStorage.setItem('clientVersion', newVersion)
    if (!(newVersion)) return
    if (!oldVersion) {
      console.log('no old version saved, reloading')
      window.location.reload(true)
    } else if (oldVersion !== newVersion) {
      console.log(`upgrading from version ${oldVersion} to ${newVersion}`)
      window.location.reload(true)
    }
  }

  render() {
    return <span />
  }
}



// WEBPACK FOOTER //
// ./src/App/Root/Version/index.js